import React from 'react';
import { connect } from 'react-redux';
import saveUriState from '../action-creators/save-uri-state';
import configHandler from '../configHandler';

const renderIframe = smeDashboardUri => {
  const containerElement = document.getElementById('SMEDashboardContainer');
  const iframe = document.createElement('iframe');

  iframe.src = smeDashboardUri;
  iframe.frameBorder = 0;
  iframe.width = "100%";
  iframe.allowFullscreen = true;
  containerElement.appendChild(iframe);
};

function redirectToLogin({ formType, ledgerId, ledgerRegion, ledgerType, }) {
  const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
  const eventer = window[eventMethod];
  const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
  eventer(messageEvent, event => {
    if (event.data === 'RedirectToLogin') {
      window.location.href = `/#/${ledgerType}/${ledgerRegion}/${formType}/${ledgerId}`;
    }
  }, false);
}

export const SmeDashboard = React.createClass({
  contextTypes: {
    router: React.PropTypes.object
  },

  propTypes: {
    backToListPath: React.PropTypes.string,
    saveUriStateToStore: React.PropTypes.func,
    params: React.PropTypes.shape({
      ledgerId: React.PropTypes.string.isRequired,
      ledgerRegion: React.PropTypes.string.isRequired,
      ledgerType: React.PropTypes.string.isRequired,
      formType: React.PropTypes.string.isRequired,
    }).isRequired,
    location: React.PropTypes.shape({
      query: React.PropTypes.shape({
        userId: React.PropTypes.string,
      }),
    }),
  },

  componentDidMount() {
    const state = {
      ledgerId: this.props.params.ledgerId,
      ledgerRegion: this.props.params.ledgerRegion,
      ledgerType: this.props.params.ledgerType,
      formType: this.props.params.formType,
    };

    this.props.saveUriStateToStore(state);

    const config = configHandler();
    const userId = this.props.location.query.userId;
    const publicApiUri = config.TAXONLINE_PUBLIC_API_URL;
    const encodedState = encodeURIComponent(btoa(JSON.stringify(state)));
    const smeDashboardUri = `${config.TAXONLINE_SME_DASHBOARD_URL}/sme-dashboard/1.0.0/?api=${publicApiUri}&state=${encodedState}&userId=${userId}`;

    redirectToLogin(state);
    renderIframe(smeDashboardUri);
  },

  render() {
    return (<div id='SMEDashboardContainer' className="myob arl-smedashboard" />)
  }
});

export default connect(
  state => ({
    backToListPath: state.navigation.backToListPath
  }),
  dispatch => ({
    saveUriStateToStore: state => dispatch(saveUriState(state))
  })
)(SmeDashboard);



// WEBPACK FOOTER //
// ./src/app/components/SmeDashboard.js